export const GET_INTEREST = 'GET_INTEREST';

